import { type InsightsClient } from 'search-insights';

import {
    type AlgoliaAnalyticsDataSource,
    getAlgoliaAnalyticsStorage,
} from '@jsmdg/browser-storage';
import { logToSentry } from '@jsmdg/react-fragment-scripts/fragment';
import {
    AlgoliaAnalyticsEventAction,
    AlgoliaAnalyticsEventPage,
    AlgoliaAnalyticsEventSource,
    sendAlgoliaObjectIdsConvertedAfterSearchEvent,
} from '@jsmdg/tracking';

export const sendAlgoliaProductConvertedEvent = ({
    insightsClient,
    productId,
}: {
    insightsClient: InsightsClient;
    productId: string;
}): void => {
    try {
        const analyticsLocalStorage = getAlgoliaAnalyticsStorage();
        const algoliaAnalyticsObject = analyticsLocalStorage.getAnalyticsObject(productId);

        if (algoliaAnalyticsObject) {
            const [algoliaAnalyticsSource, algoliaAnalyticsData] = Object.entries(
                algoliaAnalyticsObject,
            ).reduce((prev, curr) => (prev[1].timestamp > curr[1].timestamp ? prev : curr));

            sendAlgoliaObjectIdsConvertedAfterSearchEvent({
                insightsClient,
                eventName: {
                    page: AlgoliaAnalyticsEventPage.ProductDetailPage,
                    source: AlgoliaAnalyticsEventSource.BuyBox,
                    action: AlgoliaAnalyticsEventAction.ProductAddedToCart,
                },
                indexName: algoliaAnalyticsData.indexName,
                queryId: algoliaAnalyticsData.queryId,
                objectIds: [productId],
            });

            analyticsLocalStorage.removeAnalyticsDataBySource(
                productId,
                algoliaAnalyticsSource as AlgoliaAnalyticsDataSource,
            );
        }
    } catch (error) {
        logToSentry(error as Error);
    }
};
